"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { createClient } from "@/lib/supabase/client";
import posthog from "posthog-js";
import toast from "react-hot-toast";
import { FaApple } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
type SocialAuthButtonsProps = {
  nextUrl?: string;
};
export function SocialAuthButtons(t0) {
  const $ = _c(15);
  const {
    nextUrl
  } = t0;
  let t1;
  if ($[0] !== nextUrl) {
    t1 = async provider => {
      posthog.capture("oauth_start_clicked", {
        provider
      });
      const callbackUrl = `${window.location.origin}/auth/oauth/callback${nextUrl ? `?next=${encodeURIComponent(nextUrl)}` : ""}`;
      const {
        error
      } = await createClient().auth.signInWithOAuth({
        provider,
        options: {
          redirectTo: callbackUrl
        }
      });
      if (error) {
        posthog.capture("oauth_start_failed", {
          provider,
          message: error.message
        });
        toast.error(error.message);
      }
    };
    $[0] = nextUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOAuthLogin = t1;
  let t2;
  if ($[2] !== handleOAuthLogin) {
    t2 = () => handleOAuthLogin("google");
    $[2] = handleOAuthLogin;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FcGoogle className="w-5 h-5" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <Button variant="outline" className="w-full h-11 gap-3 font-medium" onClick={t2}>{t3}Continue with Google</Button>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleOAuthLogin) {
    t5 = () => handleOAuthLogin("apple");
    $[7] = handleOAuthLogin;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FaApple className="w-5 h-5" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <Button variant="outline" className="w-full h-11 gap-3 font-medium" onClick={t5}>{t6}Continue with Apple</Button>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = <div className="space-y-3">{t4}{t7}</div>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}